import type { FormViewT, InputT, PageViewT } from "@patient-watch/types";
import { useMemo } from "react";

import { useSelectCarryForwardAnswers } from "../api/selectCarryForwardValues";
import { markCarriedInputs } from "../utils/markCarriedInputs";

/**
 * The form with its carry-forward inputs carrying the diary's last answer, to pre-fill them and note it.
 * Only requests carried answers when the form has a carry-forward input. The entry being filled in is left out,
 * so its own answer stays editable.
 */
export function useCarriedForm(form: FormViewT, diaryId: string | undefined, entryId: string | undefined): FormViewT;
export function useCarriedForm(
    form: FormViewT | undefined,
    diaryId: string | undefined,
    entryId: string | undefined
): FormViewT | undefined;
export function useCarriedForm(
    form: FormViewT | undefined,
    diaryId: string | undefined,
    entryId: string | undefined
): FormViewT | undefined {
    const hasCarryForward = !!(form?.pages as PageViewT[] | undefined)?.some((page) =>
        (page.inputs as InputT[] | undefined)?.some((input) => input.carry_forward)
    );
    const { data: carriedAnswers } = useSelectCarryForwardAnswers(
        hasCarryForward ? diaryId : undefined,
        form?.form_id ?? "",
        entryId
    );
    return useMemo(
        () => (form && carriedAnswers ? markCarriedInputs(form, new Map(carriedAnswers)) : form),
        [form, carriedAnswers]
    );
}
